module.exports = __webpack_public_path__ + "media/components/assets/icons/coldcall_right-6f65d421e8076b783ccb81dbc82140ca.svg";